// @flow

import type { RouterHistory } from "react-router";

import React, { Component } from "react";
import { withRouter } from "react-router";
import { NavLink } from "react-router-dom";
import ReactGA from "react-ga";

import type { userQueryResult } from "../../data/accounts";

import "./UserNavigation.css";

type Props = {
  history: RouterHistory
} & userQueryResult;

class UserNavigation extends Component<Props> {
  logOut = () => {
    ReactGA.event({ category: "Auth", action: "Log Out" });
    window.localStorage.removeItem("graphcoolToken");
    this.props.history.push("/");
    this.props.userData.refetch();
  };

  render() {
    return (
      <div className="UserNavigation">
        {this.props.userData.user && this.props.userData.user.email ? (
          <span>
            <NavLink to="/profile" exact activeClassName="active">
              {this.props.userData.user.email}
            </NavLink>
            {" - "}
            <span className="UserNavigation-logout" onClick={this.logOut}>
              Log out
            </span>
          </span>
        ) : (
          <span>
            <NavLink to="/login" activeClassName="active">
              Log in
            </NavLink>{" "}
            or{" "}
            <NavLink to="/signup" activeClassName="active">
              Sign up
            </NavLink>
          </span>
        )}
      </div>
    );
  }
}

export default withRouter(UserNavigation);



// WEBPACK FOOTER //
// ./src/components/UserNavigation/UserNavigation.js